import React from "react";
import {Box} from "@chakra-ui/react";

interface KeyComboProps {
  value: string;
  className?: string;
}

const KeyCombo: React.FC<KeyComboProps> = ({value, className = "bg-n-400/50 text-n-300"}) => {
  return (
    <Box className={`ml-auto px-2 rounded-md caption1 ${className}`}>
      {value}
    </Box>
  );
};

export default KeyCombo;